import gql from 'graphql-tag';
const MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT = gql `
  fragment MrsNewsSyllablesActivityFragment on MrsNewsSyllablesActivity {
    rounds {
      roundIndex
      instructions
      definitionText {
        bold
        text
        italic
      }
      syllableSteps {
        stepIndex
        answer
      }
      factsSteps {
        stepIndex
        answer
        className
      }
      steps {
        stepIndex
        answer
        className
      }
    }
  }
`;
export default MRS_NEWS_SYLLABLES_ACTIVITY_FRAGMENT;
